import { useContext } from "react";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import {
  AnalyticsPageName,
  DisplayResultMessage,
  LanguageNameSpaces,
  OpenMessage,
} from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const useFreeText = (
  closeModal?: () => void,
  openMessage?: OpenMessage,
  displayResultMessage?: DisplayResultMessage
) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const {
    rawFreeText,
    setRawFreeText,
    setFreeTextTradeData,
    freeTextCreateTrade,
    freeTextCreateTradeLoading,
    isMobile,
  } = useContext(TradingTerminalContext)!;

  const inputPlaceholder =
    "qkc/btc\nbuy 700 - 750\nsell 820, 830, 840\nstop 672";

  const onOk = () => {
    if (rawFreeText?.length)
      displayResultMessage?.(
        freeTextCreateTrade({ free_text: rawFreeText }).unwrap(),
        undefined,
        t("messages.errors.parse_text_failed")
      )
        ?.then((response) => {
          setFreeTextTradeData(response);
          openMessage?.(t("messages.success.free_text_applied"), "success");
          closeModal?.();
        })
        .catch(() => {});
  };

  const helperTooltipData = {
    title: t("tooltips.free_text_title"),
    description: t("tooltips.free_text_helper"),
    articleLink:
      "https://intercom.help/cornix/en/articles/5814928-free-text-trade",
    analyticsPageName: AnalyticsPageName.CREATE_TRADE,
    analyticsFieldName: "Free Text",
  };

  return {
    onOk,
    isLoading: freeTextCreateTradeLoading,
    rawFreeText,
    setRawFreeText,
    isMobile,
    inputPlaceholder,
    helperTooltipData,
  };
};

export default useFreeText;
